import { ThemeProvider, createTheme, useTheme } from '@mui/material';
import { faIR } from '@mui/material/locale';
import {
    MRT_ActionMenuItem,
    MaterialReactTable
} from 'material-react-table';
import { MRT_Localization_FA } from 'material-react-table/locales/fa';
import { useEffect, useState } from 'react';
// import { Edit, Delete } from '@mui/icons-material';
import { Box, Grid } from '@material-ui/core';
import "./Table.css";

const Table = (props) => {
    const [data, setData] = useState(!!props.list && !!props.list.rows && props.list.rows.length > 0 ? props.list.rows : []);
    const [columns, setColumns] = useState(!!props.list && !!props.list.headers && props.list.headers.length > 0 ? props.list.headers : []);
    const [pagination, setPagination] = useState({
        pageIndex: props.pageIndex,
        pageSize: props.pageSize,
    });

    const handlePaginationChange = (updater) => {
        setPagination((prevPagination) =>
            updater instanceof Function ? updater(prevPagination) : updater,
        );
    };
    useEffect(() => {
        setData([]);
        props.getData(pagination);
    }, [pagination])
    useEffect(() => {
        setData(!!props.list && props.list.rows && props.list.rows.length > 0 ? props.list.rows : [])
        setColumns(!!props.list && !!props.list.headers && props.list.headers.length > 0 ? props.list.headers : [])
    }, [props.list?.rows?.length])
    const theme = useTheme(); //replace with your theme/createTheme
    return (
        <>
            <ThemeProvider style={{ width: '100%' }} theme={createTheme({ ...theme, direction: 'ltr' }, faIR)}>
                <div className="table" style={{ direction: 'rtl', width: '100%' }}>
                    <MaterialReactTable
                        columns={columns}
                        data={data}
                        muiDetailPanelProps={() => ({
                            sx: () => ({
                                backgroundColor: '#b7b7bb',
                                width: '100%',
                                "& .MuiCollapse-root": {
                                    width: '100% !important',
                                },
                            }),
                        })}
                        rowCount={Math.ceil(props.rowCount)}
                        defaultColumn={{ size: props.columnSize }}
                        columnResizeDirection="rtl"
                        // enableRowSelection: true,
                        // enableMultiRowSelection: true,
                        enableColumnFilterModes={false}
                        enableColumnOrdering={true}
                        enableColumnResizing={true}
                        // enableEditing: true,
                        enableColumnPinning={true}
                        enableRowActions={true}
                        loading={props.loading}
                        // enableExpanding: true,
                        // enableExpandAll: false,
                        enableColumnFilters={false}
                        state={{ pagination: pagination }}
                        renderDetailPanel={props?.hasDetails == false ? false : ({ row }) => (
                            <Box className="row"
                                sx={{
                                    margin: 'auto',
                                    gridTemplateColumns: '1fr 1fr',
                                    width: '100%',
                                    backgroundColor: 'transparent !important',
                                }}
                            >
                                {row?.subRows?.map(s => {
                                    return (
                                        <Grid lg={3} md={4} sm={10} xs={12} style={{ textAlign: 'right' }}>
                                            {s.original.header}: {s.original.value}
                                        </Grid>
                                    )
                                })
                                }
                            </Box>
                        )}
                        renderRowActionMenuItems={!!props?.list?.buttons && props?.list?.buttons.length > 0 ? ({ closeMenu, row, table }) => [
                            <>
                                {props?.list?.buttons.map(b => {
                                    if (typeof b.show === 'function' && !b.show(row.original)) {
                                        return null;
                                    }
                                    return (
                                        <div className='row ml-0 mr-0' key={row.original.id + '-' + b.id}>
                                            <MRT_ActionMenuItem //or just use a normal MUI MenuItem component
                                                icon={<></>}
                                                key={row.original.id + b.id}
                                                label={b.text}
                                                onClick={() => { closeMenu(); b.clicked(row.original.id, props.data) }}
                                                table={table}
                                                style={{ float: 'right' }}
                                            />
                                        </div>
                                    )
                                }
                                )}
                            </>
                        ] : false}
                        // filterFns={{
                        //     customFilterFn: (row, id, filterValue) => {
                        //         console.log(row)
                        //         console.log(id)
                        //         console.log(filterValue)
                        //         return filterValue;
                        //     },
                        // }}
                        autoResetPageIndex={false}
                        onPaginationChange={handlePaginationChange}
                        enableSelectAll={false}
                        pageIndex={props.pageIndex}
                        initialState={{
                            expanded: false,
                            pagination: pagination,
                            showColumnFilters: false,
                            loading: props.loading
                        }}
                        localization={MRT_Localization_FA}
                        filterFromLeafRows={false}
                    />
                </div>
            </ThemeProvider>
        </>
    );
};

export default Table;